module.exports = __webpack_public_path__ + "img/relevance_hmd.716e858c.svg";